import { useParams } from 'react-router-dom'
import { GiftType } from 'src/types/api'

export type MatchParams = {
  userId: string
  //Idx or couponIdx
  exception_Idx: string
  couponNumber: string
  couponType: '0' | '1' | '2' //0일반 1핫딜 2무료
  notice_detail_id: string
  brand: string
  alwaysCategory: string
  contentType: string
  paymentStatus:
    | 'payment_success'
    | 'payment_fail'
    | 'payment_cancel'
    | 'purchase_cancel'
    | 'refund_complete'
    | 'send_complete'
  telecom: string
  serviceTermsType: '0' | '1' | '2'
  free_coupon_Idx: string
  orderId: string
  orderDT: string
  brandNumber: string
  couponIdx: string
  // (0:사용가능, 1:사용완료, 2:취소, 3:환불, 4: 기간만료)
  couponStatus: '0' | '1' | '2' | '3' | '4'
  pNumber: string
  idx: string
  categoryNumber: string
  search_word: string
  pay_channel: 'aos' | 'ios' | 'web'
  payMethod: string
  pass_channel: 'aos' | 'ios' | 'web'
  gift_channel: 'web'
  passReqNum: string
  passReqType: '-1' | '0' | '1'
  isGift: '0' | '1' //0: 기본, 1:선물
  giftIdx: string
  giftType: `${GiftType}`
  requestId: string
  pCode: string
}
const useParamsType = () => {
  const params = useParams()
  return params as MatchParams
}
export default useParamsType
